import { UserAction } from "@/components/TopNavigation/types"

export const handleSegueSearch = (
    userAction: UserAction,
    dataType,
    setSearchTerm: (value: string) => void,
    segueToProfile: ({ id }: { id: number }, value: number) => void,
    segueToSearch: ({ initialFilter, quorumDataType }: { initialFilter: object; quorumDataType: number }) => void,
    closeSearchPopdown: () => void,
) => {
    if (!dataType) {
        return null
    }

    if (userAction.safedsearch_id) {
        segueToSearch({
            initialFilter: {
                advanced_search: userAction.safedsearch.filters[0].advanced_search,
            },
            quorumDataType: dataType.value,
        })
        setSearchTerm(userAction.safedsearch.filters[0].advanced_search)
    } else {
        segueToProfile(
            {
                id: userAction[dataType.related_pk_field],
            },
            dataType.value,
        )
        setSearchTerm("")
    }

    closeSearchPopdown()
}
